import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

/** The interface with error detail */
export interface ErrorDetail {
  ok: boolean;                // true if operation is ok, false if not
  message: string;            // raw error message
  messageTranslation: string; // translated error message  (optional)
  errors: Array<string>;      // list of errors (optional)
}

/**
 * This class handles errors like server side response, server side validation, etc.
 * A common use is to catch post or get requests to the server and manage errors (using catchError).
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor() { }

  /**
   * Handle http error
   *
   * @param error an instance of HttpErrorResponse
   * @return an observable with the error description
   */
  public handleHttpError(error: HttpErrorResponse): Observable<ErrorDetail> {
    let msg = '';
    let messageTranslation: string = null;
    let errors = [];
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      msg = error.error.message;
    } else if (error.error) {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      msg = error.error.message;
      messageTranslation = error.error.messageTranslation;

      if (error.error.errors) {
        errors = error.error.errors;
      }
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      error.error.message = error.error;
      msg = error.message;
    }
    // return an observable with a user-facing error message
    return of({
      ok: false,
      message: msg,
      messageTranslation,
      errors
    });
  }
}
